export default "__VITE_PUBLIC_ASSET__924ca5f1__"